<template>
    <div v-loading="! areaId || ! areaLocations || isAreaDirty || isAreaLocationDirty" class="area-form">
        <div v-if="areaId && areaLocations">
            <el-form-item label="ZIP Codes">
                <el-input type="textarea" v-model="areaLocations.inclusion_zip_codes" rows="5" />

                <el-button type="primary" size="small" plain @click="updatedLocationZipCodes(areaLocations.inclusion_zip_codes, false)" style="margin-top: 15px">
                    Save ZIP Codes
                </el-button>
            </el-form-item>
            <el-form-item label="Locations">
                <div v-for="(area_location, index) in areaLocations.inclusion_locations" :key="index" style="width: 100%; display: flex; justify-content: space-between; margin-bottom: 15px">
                    <template v-if="area_location.type === 'state'">
                        {{ area_location.location_name }}
                    </template>
                    <template v-else>
                        <map-autocomplete
                            v-if="gmapsObj !== null"
                            :gmaps-obj="gmapsObj"
                            :map="map"
                            :location="area_location.location_name"
                            @updated="updatedLocationFromGeo(area_location, ...arguments)"
                            style="flex: 1 0 250px; padding-right: 15px;"
                        ></map-autocomplete>

                        <div style="flex: 0 0 280px; display: flex">
                            <el-form-item style="width: 170px; margin-right: 10px">
                                <el-input v-model="area_location.radius_miles">
                                    <template slot="append">miles</template>
                                </el-input>
                            </el-form-item>
                            <el-button 
                                v-if="area_location.radius_miles_original && area_location.radius_miles_original != area_location.radius_miles"
                                type="primary" 
                                size="small" 
                                plain 
                                @click="updatedLocationRadius(area_location)"
                            >
                                Save radius
                            </el-button>
                        </div>
                    </template>

                    <div style="flex: 1 0 250px; text-align: right">
                        <a href="#" class="text-danger" @click.prevent="removeAreaLocation(areaLocations.inclusion_locations, index)">
                            <span aria-hidden="true" class="fa fa-times" style="padding-right: 5px;"></span>Delete
                        </a>
                    </div>
                </div>

                <el-button type="primary" size="small" plain @click="addCityRadius(false)">
                    Add Location
                </el-button>
            </el-form-item>

            <el-form-item label="States">
                <div v-for="(area_location, index) in areaLocations.inclusion_states" :key="index" style="width: 100%; display: flex; justify-content: space-between; margin-bottom: 15px">
                    <el-select v-model="area_location.location_name" @change="updateLocationNationwideOrState(area_location)" filterable>
                        <el-option
                            v-for="item in list.state_options"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>

                    <div style="flex: 1 0 250px; text-align: right">
                        <a href="#" class="text-danger" @click.prevent="removeAreaLocation(areaLocations.inclusion_states, index)">
                            <span aria-hidden="true" class="fa fa-times" style="padding-right: 5px;"></span>Delete
                        </a>
                    </div>
                </div>

                <el-button type="primary" size="small" plain @click="addState(false)">
                    Add State
                </el-button>
            </el-form-item>

            <el-collapse v-model="accordition" style="margin-top: 45px">
                <el-collapse-item name="exclusions">
                    <template slot="title">
                        <b>Exclusions</b>
                    </template>
                    <el-form-item label="ZIP Codes">
                        <el-input type="textarea" v-model="areaLocations.exclusion_zip_codes" rows="5" />

                        <el-button type="primary" size="small" plain @click="updatedLocationZipCodes(areaLocations.exclusion_zip_codes, true)" style="margin-top: 15px">
                            Save ZIP Codes
                        </el-button>
                    </el-form-item>
                    <el-form-item label="Locations">
                        <div v-for="(area_location, index) in areaLocations.exclusion_locations" :key="index" style="width: 100%; display: flex; justify-content: space-between; margin-bottom: 15px">
                            <template v-if="area_location.type === 'state'">
                                {{ area_location.location_name }}
                            </template>
                            <template v-else>
                                <map-autocomplete
                                    v-if="gmapsObj !== null"
                                    :gmaps-obj="gmapsObj"
                                    :map="map"
                                    :location="area_location.location_name"
                                    @updated="updatedLocationFromGeo(area_location, ...arguments)"
                                    style="flex: 1 0 250px; padding-right: 15px;"
                                ></map-autocomplete>

                                <div style="flex: 0 0 280px; display: flex">
                                    <el-form-item style="width: 170px; margin-right: 10px">
                                        <el-input v-model="area_location.radius_miles">
                                            <template slot="append">miles</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-button 
                                        v-if="area_location.radius_miles_original && area_location.radius_miles_original != area_location.radius_miles"
                                        type="primary" 
                                        size="small" 
                                        plain 
                                         @click="updatedLocationRadius(area_location)"
                                    >
                                        Save radius
                                    </el-button>
                                </div>
                            </template>

                            <div style="flex: 1 0 250px; text-align: right">
                                <a href="#" class="text-danger" @click.prevent="removeAreaLocation(areaLocations.exclusion_locations, index)">
                                    <span aria-hidden="true" class="fa fa-times" style="padding-right: 5px;"></span>Delete
                                </a>
                            </div>
                        </div>

                        <el-button type="primary" size="small" plain @click="addCityRadius(true)">
                            Add Location
                        </el-button>
                    </el-form-item>

                    <el-form-item label="States">
                        <div v-for="(area_location, index) in areaLocations.exclusion_states" :key="index" style="width: 100%; display: flex; justify-content: space-between; margin-bottom: 15px">
                            <el-select v-model="area_location.location_name" @change="updateLocationNationwideOrState(area_location)" filterable>
                                <el-option
                                    v-for="item in list.state_options"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>

                            <div style="flex: 1 0 250px; text-align: right">
                                <a href="#" class="text-danger" @click.prevent="removeAreaLocation(areaLocations.exclusion_states, index)">
                                    <span aria-hidden="true" class="fa fa-times" style="padding-right: 5px;"></span>Delete
                                </a>
                            </div>
                        </div>

                        <el-button type="primary" size="small" plain @click="addState(true)">
                            Add State
                        </el-button>
                    </el-form-item>

                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
import MapAutocomplete from './map-autocomplete';

export default {
        components: { 
            MapAutocomplete 
        },
        props: {
            gmapsObj: { type: Object, required: true },
            map: { type: Object, required: false },
            areaId: { type: Number, required: false },
            areaLocations: { type: Object, required: false },
            isAreaDirty: { type: Boolean, required: true },
            list: { type: Object, required: true },
        },
        data() {
            return {
                errorMessage: null,
                autocomplete: null,
                isAreaLocationDirty: false,
                accordition: [],
            };
        },
        watch: {
            areaLocations() {
                if (this.areaLocations.exclusion_locations.length || this.areaLocations.exclusion_zip_codes.length) {
                    this.accordition = ['exclusions'];
                }
            }
        },
        methods: {
            addCityRadius(isExclusion) {
                if(isExclusion) {
                    this.areaLocations.exclusion_locations.push({
                        id: null,
                        is_exclusion: 1,
                        type: "city-radius",
                        zip_code: null,
                        city: "",
                        state_code: "",
                        radius_miles: 50,
                        zip_codes: "",
                        location_name: "",
                    });
                } else {
                    this.areaLocations.inclusion_locations.push({
                        id: null,
                        is_exclusion: 0,
                        type: "city-radius",
                        zip_code: null,
                        city: "",
                        state_code: "",
                        radius_miles: 50,
                        zip_codes: "",
                        location_name: "",
                    });
                }
            },
            addState(isExclusion) {
                if(isExclusion) {
                    this.areaLocations.exclusion_states.push({
                        id: null,
                        is_exclusion: 1,
                        type: "state",
                        zip_code: null,
                        city: "",
                        state_code: "",
                        radius_miles: null,
                        zip_codes: "",
                        location_name: "",
                    });
                } else {
                    this.areaLocations.inclusion_states.push({
                        id: null,
                        is_exclusion: 0,
                        type: "state",
                        zip_code: null,
                        city: "",
                        state_code: "",
                        radius_miles: null,
                        zip_codes: "",
                        location_name: "",
                    });
                }
            },
            removeAreaLocation(locations, index) {
                let location = locations[index];

                if(! location.id) {
                    locations.splice(index, 1);
                    return;
                }

                this.isAreaLocationDirty = true;
                axios.post(this.url(`admin/area/remove-location`), {
                    area_id: this.areaId,
                    area_location_id: location.id,
                }).finally(() => {
                    this.$emit('process');
                    this.isAreaLocationDirty = false;
                });
            },
            updatedLocationZipCodes(zipCodes, isExclusion) {
                this.isAreaLocationDirty = true;

                axios.post(this.url(`admin/area/update-location-zip-codes`), {
                    area_id: this.areaId,
                    is_exclusion: isExclusion,
                    zip_codes: zipCodes,
                }).finally(() => {
                    this.$emit('process');
                    this.isAreaLocationDirty = false;
                });
            },
            updatedLocationFromGeo(area_location, autocompleteData) {
                let postData = area_location;
                postData.area_id = this.areaId;
                postData.autocomplete = autocompleteData;

                this.isAreaLocationDirty = true;

                axios.post(this.url(`admin/area/update-location-from-geo`), postData)
                    .finally(() => {
                    this.$emit('process');
                    this.isAreaLocationDirty = false;
                });
            },
            updatedLocationRadius(area_location) {
                let postData = area_location;
                postData.area_id = this.areaId;

                this.isAreaLocationDirty = true;

                axios.post(this.url(`admin/area/update-location-radius`), postData)
                    .finally(() => {
                    this.$emit('process');
                    this.isAreaLocationDirty = false;
                });
            },
            updateLocationNationwideOrState(area_location) {
                this.isAreaLocationDirty = true;

                axios.post(this.url(`admin/area/update-location-nationwide-or-state`), {
                    id: area_location.id,
                    area_id: this.areaId,
                    is_exclusion: area_location.is_exclusion,
                    location_name: area_location.location_name,
                })
                    .finally(() => {
                    this.$emit('process');
                    this.isAreaLocationDirty = false;
                });
            },
        },
    };
</script>

<style scoped>
    .pac-container {
        z-index: 2100; /*over element ui dialog*/
    }
    .el-collapse-item .el-textarea__inner {
        background: #fef0f0;
    }
    .area-form::v-deep .el-form-item__label {
        float: none;
    }
</style>
